import { render, staticRenderFns } from "./screen_share.vue?vue&type=template&id=eb891be2&scoped=true&"
import script from "./screen_share.vue?vue&type=script&lang=js&"
export * from "./screen_share.vue?vue&type=script&lang=js&"
import style0 from "./screen_share.vue?vue&type=style&index=0&id=eb891be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb891be2",
  null
  
)

export default component.exports